import React from "react";

export const MallContext = React.createContext();
export const MallDispatchContext = React.createContext();



function MallProvider({children}) {
    const [state,setstate] = React.useState(null)
    return(
        <MallContext.Provider value={state}>
            <MallDispatchContext.Provider value={setstate} >
                {children}
            </MallDispatchContext.Provider>
        </MallContext.Provider>
    )
}

export {MallProvider};
